import React from 'react';
import { MicroCTA } from './shared/MicroCTA';
export function Chapter5() {
  return <section className="py-8 border-t border-gray-200" id="protocol" data-id="element-110">
      <div className="mb-6" data-id="element-111">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9emHb4G9TexQVvocgrHCZ2/794a7bb8-8f54-44a3-9f2b-91dec758dbeb_min.webp" alt="Äldre kvinna med silvervitt hår i vit kofta som använder sin laptop på kvällen" className="w-full h-auto rounded-lg shadow-md object-cover" style={{
        height: '400px'
      }} width="1200" height="400" data-id="element-112" />
      </div>
      <h2 className="text-2xl font-bold mb-6" data-id="element-113">
        Min anteckningsbok (åtta veckor som förändrade takten i mitt huvud)
      </h2>
      <p className="mb-4 text-lg" data-id="element-114">
        Dagboken blev mitt ankare. Ett sätt att mäta förändringar som var för
        subtila för att märkas dag för dag, men som över tid bildade ett
        mönster. Här är vad jag skrev:
      </p>
      <div className="space-y-6 my-6" data-id="element-115">
        <div className="flex items-start" data-id="element-116">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-117">
            <span className="font-bold" data-id="element-118">1</span>
          </div>
          <div data-id="element-119">
            <h3 className="text-xl font-bold mb-2" data-id="element-120">
              Vecka 1 – Inga fyrverkerier
            </h3>
            <p className="text-lg" data-id="element-121">
              Måndag: Tog kapslarna med frukost. Inget särskilt att rapportera.
              Tappade fortfarande bort mig i ett samtal med en kollega.
            </p>
            <p className="text-lg" data-id="element-122">
              Onsdag: Vaknade med huvudvärk. Undrar om det är relaterat? Kanske
              bara för lite sömn.
            </p>
            <p className="text-lg" data-id="element-123">
              Fredag: Huvudvärken borta. Fortfarande inga märkbara förändringar.
              Det hände, ärligt talat, inte så mycket. Jag letade inte efter
              mirakel heller. Jag letade efter en känsla av att vara på väg.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-124">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-125">
            <span className="font-bold" data-id="element-126">2</span>
          </div>
          <div data-id="element-127">
            <h3 className="text-xl font-bold mb-2" data-id="element-128">
              Vecka 2 – Små ljus i förmiddagen
            </h3>
            <p className="text-lg" data-id="element-129">
              Tisdag: Läste en artikel från början till slut utan att backa i
              stycket. Kan vara en tillfällighet, men det kändes bra.
            </p>
            <p className="text-lg" data-id="element-130">
              Torsdag: Lagade middag efter ett komplicerat recept. Följde stegen
              utan att tappa bort mig. Erik (min man) kommenterade att det var
              länge sedan jag gjorde den rätten. Jag sa inte varför.
            </p>
            <p className="text-lg" data-id="element-131">
              Söndag: Fler dagar när jag känner mig "klar" i huvudet. Inte varje
              dag – men fler än förr. Det var blygsamt. Men det var mitt.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-132">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-133">
            <span className="font-bold" data-id="element-134">3</span>
          </div>
          <div data-id="element-135">
            <h3 className="text-xl font-bold mb-2" data-id="element-136">
              Vecka 3 – Orden vänder hem
            </h3>
            <p className="text-lg" data-id="element-137">
              Måndag: Telefonsamtal med min dotter. Mitt i samtalet nämnde hon
              sin kollega – den vars namn jag alltid glömmer. Men den här gången
              kom det till mig direkt. "Hur går det för Johanna?" frågade jag,
              utan att behöva famla efter namnet.
            </p>
            <p className="text-lg" data-id="element-138">
              Onsdag: Möte på jobbet. Presenterade ett projekt utan
              anteckningar. Kom ihåg alla punkter, i rätt ordning.
            </p>
            <p className="text-lg" data-id="element-139">
              Fredag: Det är svårt att förklara den lättnad som kommer när något
              så litet som att minnas ett namn utan ansträngning känns så stort.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-140">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-141">
            <span className="font-bold" data-id="element-142">4</span>
          </div>
          <div data-id="element-143">
            <h3 className="text-xl font-bold mb-2" data-id="element-144">Vecka 4 – Platån</h3>
            <p className="text-lg" data-id="element-145">
              Tisdag: Inga dramatiska förändringar denna vecka. Känner mig
              stabil.
            </p>
            <p className="text-lg" data-id="element-146">
              Torsdag: Fortfarande stabil. Undrar om jag nått en platå?
            </p>
            <p className="text-lg" data-id="element-147">
              Söndag: Ingenting särskilt hände. Och det var nästan det bästa.
              Inga dalar som förr. Jag fortsatte: mat, sömn, promenader – och
              Brainy vid frukost.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-148">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-149">
            <span className="font-bold" data-id="element-150">5-6</span>
          </div>
          <div data-id="element-151">
            <h3 className="text-xl font-bold mb-2" data-id="element-152">
              Vecka 5–6 – Färre tröga dagar
            </h3>
            <p className="text-lg" data-id="element-153">
              Måndag vecka 5: Deadline på jobbet. Arbetade fokuserat i tre
              timmar utan att känna mental trötthet.
            </p>
            <p className="text-lg" data-id="element-154">
              Torsdag vecka 5: Läste en bok på kvällen och märkte att jag inte
              behövde gå tillbaka för att förstå handlingen.
            </p>
            <p className="text-lg" data-id="element-155">
              Tisdag vecka 6: Jag märkte att dagarna när allt gick på sand
              plötsligt var färre. Jag kunde hålla en uppgift i taget längre.
              Jag skrev min att-göra-lista på morgonen – och kunde stryka
              punkter utan att bränna ut mig.
            </p>
            <p className="text-lg" data-id="element-156">
              Fredag vecka 6: Erik sa att jag verkar "mer närvarande" på
              sistone. Jag berättade om Brainy. Han blev förvånad – han hade
              trott att jag bara hade en bra period.
            </p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-157">
          <div className="bg-[#2e7d32] text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-158">
            <span className="font-bold" data-id="element-159">7-8</span>
          </div>
          <div data-id="element-160">
            <h3 className="text-xl font-bold mb-2" data-id="element-161">
              Vecka 7–8 – En annan sorts energi
            </h3>
            <p className="text-lg" data-id="element-162">
              Onsdag vecka 7: Hade en lång dag med möten. Tidigare skulle jag
              varit utmattad, med hjärnan i dimma vid slutet. Idag var jag
              trött, men fortfarande klar.
            </p>
            <p className="text-lg" data-id="element-163">
              Måndag vecka 8: Märker en skillnad i hur jag känner mig på
              morgonen. Inte pigg som efter tre espresso. Mer… stadig. Som en
              lampa i rätt styrka, snarare än en ficklampa som fladdrar.
            </p>
            <p className="text-lg" data-id="element-164">
              Fredag vecka 8: Åtta veckor har gått. Jag bläddrar tillbaka i min
              dagbok och ser förändringen. Det är inte dramatiskt. Det är inte
              en förvandling. Det är som att dimman har lättat, gradvis, dag för
              dag. Jag känner mig mer som... mig.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white p-5 rounded-lg shadow-sm my-6" data-id="element-165">
        <p className="text-lg" data-id="element-166">
          <strong data-id="element-167">Pris per dag:</strong> ca 6,23 kr (187 kr / 30 dagar). Mindre
          än en kaffe på stan, för ett stöd du märker i vardagen.
        </p>
      </div>
      <div className="mt-6" data-id="element-168">
        <MicroCTA text="Hur formulan fungerar" href="#ingredients" className="text-right" data-id="element-169" />
      </div>
    </section>;
}